export default __webpack_public_path__ + "static/coctail-05-64bb4a62846222b6a369cafae2c55468.png";